import React from "react";

function Motivator() {
  return (
    <>
      <div className="Motivator bg-gray-900 p-20">
        <h1 className="text-center p-20 text-white mb-2 text-2xl font-extrabold leading-none tracking-tight text-gray-900 md:text-2xl lg:text-5xl dark:text-white">
          Unlock Your Full Potential with <br className="mt-5"></br>CurioCode
          Solution
          <br></br>
          <br></br>
          <a
            href="./Applynow.jsx"
            type="button"
            className="text-center rounded border-2 border-neutral-50 px-[46px] pt-[14px] pb-[12px] text-sm font-medium uppercase leading-normal text-neutral-50 transition duration-150 ease-in-out hover:border-neutral-100 hover:bg-neutral-100 hover:bg-opacity-10 hover:text-neutral-100 focus:border-neutral-100 focus:text-neutral-100 focus:outline-none focus:ring-0 active:border-neutral-200 active:text-neutral-200"
            data-te-ripple-init=""
            data-te-ripple-color="light"
          >
            Apply now
          </a>
        </h1>
      </div>
    </>
  );
}

export default Motivator;
